"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectBroadcastAgent = void 0;
const NetworkAgent_1 = require("../network/NetworkAgent");
const model_1 = require("../../../data/model");
const linkup_1 = require("../../../net/linkup");
const logging_1 = require("../../../util/logging");
const multimap_1 = require("../../../util/multimap");
class ObjectBroadcastAgent {
    constructor(object, broadcastedSuffixBits) {
        if (broadcastedSuffixBits === undefined) {
            broadcastedSuffixBits = ObjectBroadcastAgent.defaultBroadcastedSuffixBits;
        }
        this.literalContext = object.toLiteralContext();
        this.listening = new multimap_1.MultiMap();
        this.broadcastedSuffixBits = broadcastedSuffixBits;
    }
    static agentIdForHash(hash, suffixBits = this.defaultBroadcastedSuffixBits) {
        return ObjectBroadcastAgent.agentIdForHexHashSuffix(model_1.Hashing.toHex(hash), suffixBits);
    }
    static agentIdForHexHashSuffix(hexSuffix, suffixBits = this.defaultBroadcastedSuffixBits) {
        return 'object-broadcast-agent-for-' + ObjectBroadcastAgent.trimHexSuffix(hexSuffix, suffixBits);
    }
    static hexSuffixFromHash(hash, suffixBits) {
        return ObjectBroadcastAgent.trimHexSuffix(model_1.Hashing.toHex(hash), suffixBits);
    }
    static trimHexSuffix(hashSuffix, suffixBits) {
        if (suffixBits % 4 !== 0) {
            throw new Error('ObjectBroadcastAgent: suffixBits needs to be ' +
                'a multiple of 4 (received ' + suffixBits + ')');
        }
        const suffixNibbles = suffixBits / 4;
        return hashSuffix.slice(-suffixNibbles);
    }
    static linkupIdForHexHashSuffix(hexSuffix) {
        return 'broadcast-' + hexSuffix;
    }
    getAgentId() {
        return ObjectBroadcastAgent.agentIdForHash(this.literalContext.rootHashes[0], this.broadcastedSuffixBits);
    }
    ready(pod) {
        this.pod = pod;
        for (const linkupServer of this.listening.keys()) {
            this.createListener(linkupServer);
        }
        ObjectBroadcastAgent.log.debug('Started ObjectBroadcastAgent for ' + this.literalContext.rootHashes[0]);
    }
    listenOn(linkupServers, replyEndpoints) {
        for (const linkupServer of linkupServers) {
            for (const replyEndpoint of replyEndpoints) {
                this.listening.add(linkupServer, replyEndpoint);
            }
            if (this.pod !== undefined) {
                this.createListener(linkupServer);
            }
        }
    }
    createListener(linkupServer) {
        const networkAgent = this.getNetworkAgent();
        const broadcastLinkupId = ObjectBroadcastAgent.linkupIdForHexHashSuffix(ObjectBroadcastAgent.hexSuffixFromHash(this.literalContext.rootHashes[0], this.broadcastedSuffixBits));
        let address = new linkup_1.LinkupAddress(linkupServer, broadcastLinkupId);
        networkAgent.listenForLinkupMessages(address.url());
        ObjectBroadcastAgent.log.trace(() => 'Listening for linkup messages on ' + address.url());
    }
    receiveLocalEvent(ev) {
        const MIN_BITS_TO_ANSWER = 36;
        if (ev.type === NetworkAgent_1.NetworkEventType.LinkupMessageReceived) {
            const msg = ev.content;
            if (msg.agentId === this.getAgentId()) {
                const req = msg.content;
                ObjectBroadcastAgent.log.trace(() => 'Received object broadcast query for ' + req.hashSuffix + ' (match: ' + this.hashSuffixMatch(req.hashSuffix) + ')');
                if (req.hashSuffix.length * 4 >= MIN_BITS_TO_ANSWER && this.hashSuffixMatch(req.hashSuffix)) {
                    const networkAgent = this.getNetworkAgent();
                    const dstAddress = linkup_1.LinkupAddress.fromURL(msg.destination);
                    for (const replyEndpoint of this.listening.get(dstAddress.serverURL)) {
                        if (msg.source !== replyEndpoint) {
                            ObjectBroadcastAgent.log.debug('Answering query from ' + msg.source + ' for suffix ' + req.hashSuffix + ' from endpoint ' + replyEndpoint);
                            const reply = {
                                source: replyEndpoint,
                                literalContext: this.literalContext
                            };
                            networkAgent.sendLinkupMessage(linkup_1.LinkupAddress.fromURL(replyEndpoint), linkup_1.LinkupAddress.fromURL(msg.source), req.agentId, reply);
                        }
                    }
                }
            }
        }
    }
    shutdown() {
        // TODO: stop listening on the linkup addresses
    }
    hashSuffixMatch(suffix) {
        //const receivedBits = suffix.length * 4;
        let ownSuffix = model_1.Hashing.toHex(this.literalContext.rootHashes[0]).slice(-suffix.length);
        return ownSuffix === suffix;
    }
    // shorthand functions
    getNetworkAgent() {
        var _a;
        return (_a = this.pod) === null || _a === void 0 ? void 0 : _a.getAgent(NetworkAgent_1.NetworkAgent.AgentId);
    }
}
exports.ObjectBroadcastAgent = ObjectBroadcastAgent;
ObjectBroadcastAgent.log = new logging_1.Logger(ObjectBroadcastAgent.name, logging_1.LogLevel.INFO);
ObjectBroadcastAgent.defaultBroadcastedSuffixBits = 36;
//# sourceMappingURL=ObjectBroadcastAgent.js.map